export const SIGNUP_SUCCESS = "signup/success";
export const SIGNUP_FAILED = "signup/failed";
export const SIGNUP_RESET = "signup/reset";